import { ReactNode } from 'react'
import { MdInfo } from 'react-icons/md'

import { Card } from 'src/components/atoms/Card'
import { Tooltip } from 'src/components/atoms/Tooltip'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

export interface FormCardProps {
  children: ReactNode
  heading: string
  tooltipContent: ReactNode
}

export const FormCard = ({
  heading,
  children,
  tooltipContent
}: FormCardProps) => {
  return (
    <Card
      size='small'
      corner='square'
      className='flex-1 bg-linen! [&_.form-label]:text-forestDeep! [&_.form-input-wrapper]:rounded-none! [&_.form-input-wrapper]:border-black!'
    >
      <div className='flex justify-between'>
        <div className='flex-1'>
          <TypographyRebrand variant='introduction' color='forestDeep'>
            {heading}
          </TypographyRebrand>
        </div>
        <Tooltip overlay={tooltipContent} overlayStyle={{ maxWidth: 300 }}>
          <MdInfo className='inline-block text-forestDeep mx-2' size='24px' />
        </Tooltip>
      </div>
      <div>{children}</div>
    </Card>
  )
}
